import { render } from "./CustomInputTextArea.vue?vue&type=template&id=bc469f5c&scoped=true"
import script from "./CustomInputTextArea.vue?vue&type=script&lang=js"
export * from "./CustomInputTextArea.vue?vue&type=script&lang=js"

import "./CustomInputTextArea.vue?vue&type=style&index=0&id=bc469f5c&scoped=true&lang=css"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc469f5c"]])

export default __exports__